import script from "./SubMenusBook.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubMenusBook.vue?vue&type=script&setup=true&lang=ts"

import "./SubMenusBook.vue?vue&type=style&index=0&id=52ad188f&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ad188f"]])

export default __exports__